import type { BlokProps } from "@trydig/storyblok";
import { ManualIcon } from "@/components/icons/Manual";
import { sbLink } from "@/lib/storyblok/link";
import type { BlokDownloadLink, BlokLink, BlokManual } from "@/storyblok";
import BlokWrap from "../../BlokWrap";
import styles from "./ManualBlok.module.css";

const getDownloadLink = (link: BlokManual["link"]) => {
	const realLink = link?.at(0);
	if (!realLink) return;

	if ("href" in realLink) {
		return {
			href: sbLink(realLink.href as BlokLink["href"])?.href,
			downloadable: false,
		};
	}

	if ("file" in realLink) {
		return {
			href: (realLink as BlokDownloadLink).file?.filename,
			downloadable: true,
		};
	}
};

export const ManualBlok = ({ blok }: BlokProps<BlokManual>) => {
	const link = getDownloadLink(blok.link);

	return (
		<BlokWrap editable={blok} className={styles.root}>
			<ManualIcon className={styles.icon} />

			<div className={styles.content}>
				<p className={styles.title}>{blok.title}</p>
				<p className={styles.description}>{blok.description}</p>
				{link?.href && (
					<a
						className={styles.link}
						download={link?.downloadable}
						href={link?.href}
						target="_blank"
						rel="noreferrer"
					>
						Download PDF
					</a>
				)}
			</div>
		</BlokWrap>
	);
};
